import { PaymentDto, TenderType } from '@symphony-solo/domain/payments/src';

export class TransactionLineTenderDto {
  public tenderType: TenderType;
  public tenderedPayment: PaymentDto;
  public tenderedAmount: number;
  public changePayment: PaymentDto;
  public changeAmount: number;
}
